exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!./assets/css/agency.min.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n#mainNav .container .navbar-brand {\r\n  color: #fed136;\r\n  font-family: \"sans-serif\"!important;\r\n}\r\n\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./src/styles.css
// module id = 141
// module chunks = 1